export const assignedOrderPluralMapping = {
  '=0': 'None',
  '=1': '1 Assigned',
  other: '# Assigned',
};
